/* FadeOut loader on window.load(); */
jQuery(window).load(function(){
	jQuery("#loader").fadeOut();
});
/* Fallback fadeOut on document.ready(); */
jQuery( document ).ready(function(){
	setTimeout(function(){ 
		jQuery("#loader").fadeOut();
	}, 4000);
});